import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  DataGrid,
  GridToolbar
} from "@mui/x-data-grid";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Select, MenuItem
} from "@mui/material";
import { saveReferral, getReferrals , updateReferralStatus,getReferralStatus} from '../service/referralService';


import { useLanguage } from "../context/LanguageContext";

  
 
const ReferralManager = () => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
const [statuses, setStatuses] = useState([]);
    const { language, changeLanguage } = useLanguage();
  // form state
  const [formData, setFormData] = useState({
    referralId: null,
    friendName: "",
    friendEmail: "",
    friendPhone: "",
    referralStatus: "",
    referralStatusId: "" 
  });

  const [openForm, setOpenForm] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedReferral, setSelectedReferral] = useState(null);

  // fetch referrals
  const fetchReferrals = async () => {
    setLoading(true);
    try {
      const res = await getReferrals();
      setReferrals(res.data);
    } catch (err) {
      console.error("Error fetching referrals", err);
    } finally {
      setLoading(false);
    }
  };
  
   const fetchStatuses = async () => {
    try {
      const res = await getReferralStatus();
      setStatuses(res.data);
    } catch (err) {
      console.error("Error fetching referral statuses", err);
    }
  };

  useEffect(() => {
    fetchReferrals();
    fetchStatuses();
  }, []);

  // form input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // save referral (create or update)
  const handleSave = async () => {
    try {
      if (formData.referralId) {
        await updateReferralStatus(formData.referralId, formData.referralStatus);
      } else {
        await saveReferral(formData);
      }
      fetchReferrals();
      setOpenForm(false);
      setFormData({ referralId: null, friendName: "", friendEmail: "", friendPhone: "", referralStatus: "" });
    } catch (err) {
      console.error("Error saving referral", err);
    }
  };

  // delete referral
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this referral?")) return;
    try {
      await axios.delete(`/api/referrals/${id}`);
      fetchReferrals();
    } catch (err) {
      console.error("Error deleting referral", err);
    }
  };

  // open edit
  const handleEdit = (referral) => {
    setFormData(referral);
    setOpenForm(true);
  };

  // open details
  const handleView = (referral) => {
    setSelectedReferral(referral);
    setOpenDetails(true);
  };

  // columns for DataGrid
  const columns = [
    { field: "referralId", headerName: "ID", width: 90 },
    { field: "friendName", headerName: "Friend Name", flex: 1 },
    { field: "friendEmail", headerName: "Email", flex: 1 },
    { field: "friendPhone", headerName: "Phone", flex: 1 },
    { field: "bonusAwarded", headerName: "Bonus Awarded", width: 150, renderCell: (params) => params.value ? "Yes" : "No" },
     { field: "orderValue", headerName: "Order Value", width: 150 },
    { field: "referralStatus", headerName: "Referral Status", width: 150 },
    { field: "createdAt", headerName: "Created At", width: 200 },
    {
      field: "actions",
      headerName: "Actions",
      width: 250,
      renderCell: (params) => (
        <>
          <Button
            size="small"
            variant="outlined"
            onClick={() => handleEdit(params.row)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={() => handleDelete(params.row.referralId)}
            style={{ marginRight: 8 }}
          >
            Delete
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => handleView(params.row)}
          >
            View
          </Button>
        </>
      )
    }
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Referral Management</h1>

      <Button
        variant="contained"
        color="primary"
        onClick={() => setOpenForm(true)}
        style={{ marginBottom: "1rem" }}
      >
        Add Referral
      </Button>

      {/* DataGrid with filter/search */}
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          rows={referrals}
          columns={columns}
          getRowId={(row) => row.referralId}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          loading={loading}
          components={{ Toolbar: GridToolbar }}
        />
      </div>

      {/* Form Dialog */}
      <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{formData.referralId ? "Edit Referral" : "Add Referral"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Friend Name"
            name="friendName"
            fullWidth
            value={formData.friendName}
            onChange={handleChange}
                     InputProps={{
                        readOnly: formData.referralId !== null,
                    }}
          />
          <TextField
            margin="dense"
            label="Friend Email"
            name="friendEmail"
            type="email"
            fullWidth
            value={formData.friendEmail}
            onChange={handleChange}
                     InputProps={{
                        readOnly: formData.referralId !== null,
                    }}
          />
          <TextField
            margin="dense"
            label="Friend Phone"
            name="friendPhone"
            fullWidth
            value={formData.friendPhone}
            onChange={handleChange}
                     InputProps={{
                        readOnly: formData.referralId !== null,
                    }}
          />

  <Select
    labelId="status-label"
    name="referralStatus"
    value={formData.referralStatus}
    onChange={handleChange}
  >
    {statuses.map((status) => {
       const translatedValue = status.translations?.find(t => t.languageCode === language);
       return (
      <MenuItem key={status.code} value={status.code}>
          {translatedValue ? translatedValue.value : status.code}
      </MenuItem>
);
    })}
  </Select>

              
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Details Dialog */}
      <Dialog open={openDetails} onClose={() => setOpenDetails(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Referral Details</DialogTitle>
        <DialogContent dividers>
          {selectedReferral && (
            <div className="space-y-2">
              <p><strong>ID:</strong> {selectedReferral.referralId}</p>
              <p><strong>Friend Name:</strong> {selectedReferral.friendName}</p>
              <p><strong>Email:</strong> {selectedReferral.friendEmail}</p>
              <p><strong>Phone:</strong> {selectedReferral.friendPhone}</p>
              <p><strong>Bonus Awarded:</strong> {selectedReferral.bonusAwarded ? "Yes" : "No"}</p>
              <p><strong>Order Value:</strong> {selectedReferral.orderValue}</p>
              <p><strong>Created At:</strong> {selectedReferral.createdAt}</p>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDetails(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ReferralManager;
